import { render } from "./ToolbarView.vue?vue&type=template&id=0234f7e2"
import script from "./ToolbarView.vue?vue&type=script&lang=js"
export * from "./ToolbarView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\webDesign\\trello-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__